// Monetization / subscription screen translations
// Keys using {placeholder} markers are interpolated in the component via .replace()
export const monetization = {
  en: {
    planTitleMonthly: 'Premium Monthly',
    planTitleAnnual: 'Premium Annual',
    planDescMonthly: 'Unlock Premium Bible quiz features.',
    planDescAnnual: 'Annual Premium Bible quiz access.',
    premiumPlansTitle: 'Premium Plans',
    subscribeNow: 'Subscribe Now',
    restorePurchases: 'Restore Purchases',
    restoring: 'Restoring...',
    refresh: 'Refresh',
    loadingPlans: 'Loading subscription plans...',

    // Purchase outcomes
    purchaseSuccessTitle: 'Success!',
    purchaseSuccessMessage: 'Your subscription is now active. Enjoy your premium features!',
    purchaseFailedTitle: 'Purchase Failed',
    purchaseFailedMessage: 'Unable to complete purchase. Please try again.',
    purchaseErrorTitle: 'Purchase Error',
    purchaseErrorMessage: 'An unexpected error occurred. Please try again.',

    // Restore outcomes
    restoreSuccessTitle: 'Purchases Restored!',
    restoreSuccessMessage: 'Your subscription has been restored successfully.',
    noRestoredTitle: 'No Purchases Found',
    noRestoredMessage: 'No active subscriptions were found to restore.',
    restoreFailedTitle: 'Restore Failed',
    restoreFailedMessage: 'Unable to restore purchases. Please try again.',
    restoreErrorTitle: 'Restore Error',
    restoreErrorMessage: 'An unexpected error occurred. Please try again.',

    // Error / empty states
    errorTitle: 'Error',
    errorGenericMessage: 'Unable to open subscription management. Please check your device settings.',
    loadFailedTitle: 'Unable to Load Plans',
    loadFailedMessage: "We couldn't load subscription plans. Please check your internet connection and try again.",
    plansComingSoonTitle: 'Plans Coming Soon',
    plansComingSoonMessage: 'Subscription plans are being set up. Please check back soon.',
    noPlansTitle: 'No Plans Available',
    noPlansMessage: 'Subscription plans are being set up. Please try again shortly or check back later.',
    tryAgain: 'Try Again',

    // Active subscription banner
    activeSubscription: 'Active Subscription',
    planLabel: '{tier} Plan',
    renewsDate: 'Renews {date}',
    expiresDate: 'Expires {date}',
    manageSubscription: 'Manage Subscription',

    // Package / product cards
    perMonth: '/month',
    perYear: '/year',
    savingsPercent: 'Save {percent}%',
    mostPopular: 'MOST POPULAR',
    currentPlan: 'CURRENT PLAN',
    selected: 'Selected',
    introTrialLabel: 'Trial: {price} for {period}',

    // Legal
    autoRenewalTerms: 'Subscriptions auto-renew unless cancelled 24 hours before the end of the current period. Your account will be charged for renewal within 24 hours prior to the end of the current period. You can manage or cancel in your App Store account settings.',
    selectedPlanRenewalDisclosure: 'Selected plan: {title} for {price}{period}. Auto-renews until canceled in your App Store account settings.',
    termsLink: 'Terms of Use (EULA)',
    privacyLink: 'Privacy Policy',
    ok: 'OK',
  },
  fr: {
    planTitleMonthly: 'Premium Mensuel',
    planTitleAnnual: 'Premium Annuel',
    planDescMonthly: 'Débloquez les fonctions Premium du quiz.',
    planDescAnnual: 'Accès annuel au quiz biblique Premium.',
    premiumPlansTitle: 'Plans Premium',
    subscribeNow: "S'abonner",
    restorePurchases: 'Restaurer les achats',
    restoring: 'Restauration...',
    refresh: 'Actualiser',
    loadingPlans: 'Chargement des plans...',
    purchaseSuccessTitle: 'Bravo !',
    purchaseSuccessMessage: 'Votre abonnement est maintenant actif. Profitez de vos fonctions premium !',
    purchaseFailedTitle: "Échec de l'achat",
    purchaseFailedMessage: "Impossible de finaliser l'achat. Veuillez réessayer.",
    purchaseErrorTitle: "Erreur d'achat",
    purchaseErrorMessage: 'Une erreur inattendue est survenue. Veuillez réessayer.',
    restoreSuccessTitle: 'Achats restaurés !',
    restoreSuccessMessage: 'Votre abonnement a été restauré avec succès.',
    noRestoredTitle: 'Aucun achat trouvé',
    noRestoredMessage: 'Aucun abonnement actif à restaurer.',
    restoreFailedTitle: 'Échec de la restauration',
    restoreFailedMessage: 'Impossible de restaurer les achats. Veuillez réessayer.',
    restoreErrorTitle: 'Erreur de restauration',
    restoreErrorMessage: 'Une erreur inattendue est survenue. Veuillez réessayer.',
    errorTitle: 'Erreur',
    errorGenericMessage: "Impossible d'ouvrir la gestion des abonnements. Vérifiez les paramètres de votre appareil.",
    loadFailedTitle: 'Impossible de charger les plans',
    loadFailedMessage: 'Nous n\'avons pas pu charger les plans. Vérifiez votre connexion internet et réessayez.',
    plansComingSoonTitle: 'Plans bientôt disponibles',
    plansComingSoonMessage: 'Les plans d\'abonnement sont en cours de configuration. Revenez bientôt.',
    noPlansTitle: 'Aucun plan disponible',
    noPlansMessage: 'Les plans d\'abonnement sont en cours de configuration. Réessayez bientôt.',
    tryAgain: 'Réessayer',
    activeSubscription: 'Abonnement actif',
    planLabel: 'Plan {tier}',
    renewsDate: 'Renouvellement le {date}',
    expiresDate: 'Expire le {date}',
    manageSubscription: "Gérer l'abonnement",
    perMonth: '/mois',
    perYear: '/an',
    savingsPercent: 'Économisez {percent} %',
    mostPopular: 'LE PLUS POPULAIRE',
    currentPlan: 'PLAN ACTUEL',
    selected: 'Sélectionné',
    introTrialLabel: 'Essai : {price} pendant {period}',
    autoRenewalTerms: "Les abonnements se renouvellent automatiquement sauf annulation 24 heures avant la fin de la période en cours. Votre compte sera débité dans les 24 heures précédant la fin de la période en cours. Vous pouvez gérer ou annuler dans les réglages de votre compte App Store.",
    selectedPlanRenewalDisclosure: "Plan sélectionné : {title} pour {price}{period}. Renouvellement automatique jusqu'à annulation dans les réglages de votre compte App Store.",
    termsLink: "Conditions d'utilisation (CLUF)",
    privacyLink: 'Politique de confidentialité',
    ok: 'OK',
  },
  es: {
    planTitleMonthly: 'Premium Mensual',
    planTitleAnnual: 'Premium Anual',
    planDescMonthly: 'Desbloquea funciones Premium del quiz.',
    planDescAnnual: 'Acceso anual al quiz bíblico Premium.',
    premiumPlansTitle: 'Planes Premium',
    subscribeNow: 'Suscribirse ahora',
    restorePurchases: 'Restaurar compras',
    restoring: 'Restaurando...',
    refresh: 'Actualizar',
    loadingPlans: 'Cargando planes de suscripción...',
    purchaseSuccessTitle: '¡Listo!',
    purchaseSuccessMessage: 'Tu suscripción está activa. ¡Disfruta de las funciones premium!',
    purchaseFailedTitle: 'Compra fallida',
    purchaseFailedMessage: 'No se pudo completar la compra. Inténtalo de nuevo.',
    purchaseErrorTitle: 'Error de compra',
    purchaseErrorMessage: 'Ocurrió un error inesperado. Inténtalo de nuevo.',
    restoreSuccessTitle: '¡Compras restauradas!',
    restoreSuccessMessage: 'Tu suscripción ha sido restaurada correctamente.',
    noRestoredTitle: 'No se encontraron compras',
    noRestoredMessage: 'No se encontraron suscripciones activas para restaurar.',
    restoreFailedTitle: 'Error al restaurar',
    restoreFailedMessage: 'No se pudieron restaurar las compras. Inténtalo de nuevo.',
    restoreErrorTitle: 'Error de restauración',
    restoreErrorMessage: 'Ocurrió un error inesperado. Inténtalo de nuevo.',
    errorTitle: 'Error',
    errorGenericMessage: 'No se pudo abrir la gestión de suscripciones. Revisa la configuración de tu dispositivo.',
    loadFailedTitle: 'No se pudieron cargar los planes',
    loadFailedMessage: 'No pudimos cargar los planes de suscripción. Verifica tu conexión a internet e inténtalo de nuevo.',
    plansComingSoonTitle: 'Planes próximamente',
    plansComingSoonMessage: 'Los planes de suscripción se están configurando. Vuelve pronto.',
    noPlansTitle: 'No hay planes disponibles',
    noPlansMessage: 'Los planes de suscripción se están configurando. Inténtalo de nuevo más tarde.',
    tryAgain: 'Reintentar',
    activeSubscription: 'Suscripción activa',
    planLabel: 'Plan {tier}',
    renewsDate: 'Se renueva el {date}',
    expiresDate: 'Expira el {date}',
    manageSubscription: 'Gestionar suscripción',
    perMonth: '/mes',
    perYear: '/año',
    savingsPercent: 'Ahorra {percent} %',
    mostPopular: 'MÁS POPULAR',
    currentPlan: 'PLAN ACTUAL',
    selected: 'Seleccionado',
    introTrialLabel: 'Prueba: {price} por {period}',
    autoRenewalTerms: 'Las suscripciones se renuevan automáticamente a menos que se cancelen 24 horas antes del final del período actual. Se cobrará a tu cuenta dentro de las 24 horas previas al final del período actual. Puedes gestionar o cancelar en la configuración de tu cuenta de App Store.',
    selectedPlanRenewalDisclosure: 'Plan seleccionado: {title} por {price}{period}. Se renueva automáticamente hasta que lo canceles en la configuración de tu cuenta de App Store.',
    termsLink: 'Condiciones de uso (CLUF)',
    privacyLink: 'Política de privacidad',
    ok: 'OK',
  },
  de: {
    planTitleMonthly: 'Premium Monatlich',
    planTitleAnnual: 'Premium Jährlich',
    planDescMonthly: 'Premium-Bibelquiz-Funktionen freischalten.',
    planDescAnnual: 'Jährlicher Zugang zum Premium-Bibelquiz.',
    premiumPlansTitle: 'Premium-Pläne',
    subscribeNow: 'Jetzt abonnieren',
    restorePurchases: 'Käufe wiederherstellen',
    restoring: 'Wird wiederhergestellt...',
    refresh: 'Aktualisieren',
    loadingPlans: 'Abonnement-Pläne werden geladen...',
    purchaseSuccessTitle: 'Geschafft!',
    purchaseSuccessMessage: 'Dein Abonnement ist jetzt aktiv. Genieße die Premium-Funktionen!',
    purchaseFailedTitle: 'Kauf fehlgeschlagen',
    purchaseFailedMessage: 'Der Kauf konnte nicht abgeschlossen werden. Bitte versuche es erneut.',
    purchaseErrorTitle: 'Kauffehler',
    purchaseErrorMessage: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.',
    restoreSuccessTitle: 'Käufe wiederhergestellt!',
    restoreSuccessMessage: 'Dein Abonnement wurde erfolgreich wiederhergestellt.',
    noRestoredTitle: 'Keine Käufe gefunden',
    noRestoredMessage: 'Es wurden keine aktiven Abonnements zum Wiederherstellen gefunden.',
    restoreFailedTitle: 'Wiederherstellung fehlgeschlagen',
    restoreFailedMessage: 'Käufe konnten nicht wiederhergestellt werden. Bitte versuche es erneut.',
    restoreErrorTitle: 'Wiederherstellungsfehler',
    restoreErrorMessage: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.',
    errorTitle: 'Fehler',
    errorGenericMessage: 'Die Abonnementverwaltung konnte nicht geöffnet werden. Überprüfe die Geräteeinstellungen.',
    loadFailedTitle: 'Pläne konnten nicht geladen werden',
    loadFailedMessage: 'Wir konnten die Abonnement-Pläne nicht laden. Überprüfe deine Internetverbindung und versuche es erneut.',
    plansComingSoonTitle: 'Pläne in Kürze',
    plansComingSoonMessage: 'Die Abonnement-Pläne werden gerade eingerichtet. Schau bald wieder vorbei.',
    noPlansTitle: 'Keine Pläne verfügbar',
    noPlansMessage: 'Die Abonnement-Pläne werden gerade eingerichtet. Versuche es bald erneut.',
    tryAgain: 'Erneut versuchen',
    activeSubscription: 'Aktives Abonnement',
    planLabel: '{tier}-Plan',
    renewsDate: 'Verlängerung am {date}',
    expiresDate: 'Läuft ab am {date}',
    manageSubscription: 'Abonnement verwalten',
    perMonth: '/Monat',
    perYear: '/Jahr',
    savingsPercent: '{percent} % sparen',
    mostPopular: 'AM BELIEBTESTEN',
    currentPlan: 'AKTUELLER PLAN',
    selected: 'Ausgewählt',
    introTrialLabel: 'Testphase: {price} für {period}',
    autoRenewalTerms: 'Abonnements verlängern sich automatisch, sofern sie nicht 24 Stunden vor Ende des aktuellen Zeitraums gekündigt werden. Dein Konto wird innerhalb von 24 Stunden vor Ende des aktuellen Zeitraums belastet. Du kannst das Abonnement in deinen App Store Kontoeinstellungen verwalten oder kündigen.',
    selectedPlanRenewalDisclosure: 'Ausgewählter Plan: {title} für {price}{period}. Verlängert sich automatisch, bis du in deinen App Store Kontoeinstellungen kündigst.',
    termsLink: 'Nutzungsbedingungen (EULA)',
    privacyLink: 'Datenschutzrichtlinie',
    ok: 'OK',
  },
  pt: {
    planTitleMonthly: 'Premium Mensal',
    planTitleAnnual: 'Premium Anual',
    planDescMonthly: 'Desbloqueie recursos Premium do quiz.',
    planDescAnnual: 'Acesso anual ao quiz bíblico Premium.',
    premiumPlansTitle: 'Planos Premium',
    subscribeNow: 'Assinar agora',
    restorePurchases: 'Restaurar compras',
    restoring: 'Restaurando...',
    refresh: 'Atualizar',
    loadingPlans: 'Carregando planos de assinatura...',
    purchaseSuccessTitle: 'Sucesso!',
    purchaseSuccessMessage: 'Sua assinatura está ativa. Aproveite os recursos premium!',
    purchaseFailedTitle: 'Compra falhou',
    purchaseFailedMessage: 'Não foi possível concluir a compra. Tente novamente.',
    purchaseErrorTitle: 'Erro na compra',
    purchaseErrorMessage: 'Ocorreu um erro inesperado. Tente novamente.',
    restoreSuccessTitle: 'Compras restauradas!',
    restoreSuccessMessage: 'Sua assinatura foi restaurada com sucesso.',
    noRestoredTitle: 'Nenhuma compra encontrada',
    noRestoredMessage: 'Nenhuma assinatura ativa encontrada para restaurar.',
    restoreFailedTitle: 'Falha na restauração',
    restoreFailedMessage: 'Não foi possível restaurar as compras. Tente novamente.',
    restoreErrorTitle: 'Erro na restauração',
    restoreErrorMessage: 'Ocorreu um erro inesperado. Tente novamente.',
    errorTitle: 'Erro',
    errorGenericMessage: 'Não foi possível abrir o gerenciamento de assinaturas. Verifique as configurações do dispositivo.',
    loadFailedTitle: 'Não foi possível carregar os planos',
    loadFailedMessage: 'Não conseguimos carregar os planos de assinatura. Verifique sua conexão com a internet e tente novamente.',
    plansComingSoonTitle: 'Planos em breve',
    plansComingSoonMessage: 'Os planos de assinatura estão sendo configurados. Volte em breve.',
    noPlansTitle: 'Nenhum plano disponível',
    noPlansMessage: 'Os planos de assinatura estão sendo configurados. Tente novamente em breve.',
    tryAgain: 'Tentar novamente',
    activeSubscription: 'Assinatura ativa',
    planLabel: 'Plano {tier}',
    renewsDate: 'Renova em {date}',
    expiresDate: 'Expira em {date}',
    manageSubscription: 'Gerenciar assinatura',
    perMonth: '/mês',
    perYear: '/ano',
    savingsPercent: 'Economize {percent}%',
    mostPopular: 'MAIS POPULAR',
    currentPlan: 'PLANO ATUAL',
    selected: 'Selecionado',
    introTrialLabel: 'Teste: {price} por {period}',
    autoRenewalTerms: 'As assinaturas são renovadas automaticamente, a menos que sejam canceladas 24 horas antes do final do período atual. Sua conta será cobrada dentro de 24 horas antes do final do período atual. Você pode gerenciar ou cancelar nas configurações da sua conta da App Store.',
    selectedPlanRenewalDisclosure: 'Plano selecionado: {title} por {price}{period}. Renova automaticamente até ser cancelado nas configurações da sua conta da App Store.',
    termsLink: 'Termos de Uso (EULA)',
    privacyLink: 'Política de Privacidade',
    ok: 'OK',
  },
  ru: {
    planTitleMonthly: 'Премиум на месяц',
    planTitleAnnual: 'Премиум на год',
    planDescMonthly: 'Премиум-функции библейской викторины.',
    planDescAnnual: 'Годовой доступ к премиум-викторине.',
    premiumPlansTitle: 'Премиум-планы',
    subscribeNow: 'Подписаться',
    restorePurchases: 'Восстановить покупки',
    restoring: 'Восстановление...',
    refresh: 'Обновить',
    loadingPlans: 'Загрузка планов подписки...',
    purchaseSuccessTitle: 'Готово!',
    purchaseSuccessMessage: 'Ваша подписка активирована. Наслаждайтесь премиум-функциями!',
    purchaseFailedTitle: 'Покупка не удалась',
    purchaseFailedMessage: 'Не удалось завершить покупку. Попробуйте ещё раз.',
    purchaseErrorTitle: 'Ошибка покупки',
    purchaseErrorMessage: 'Произошла непредвиденная ошибка. Попробуйте ещё раз.',
    restoreSuccessTitle: 'Покупки восстановлены!',
    restoreSuccessMessage: 'Ваша подписка успешно восстановлена.',
    noRestoredTitle: 'Покупки не найдены',
    noRestoredMessage: 'Активных подписок для восстановления не найдено.',
    restoreFailedTitle: 'Ошибка восстановления',
    restoreFailedMessage: 'Не удалось восстановить покупки. Попробуйте ещё раз.',
    restoreErrorTitle: 'Ошибка восстановления',
    restoreErrorMessage: 'Произошла непредвиденная ошибка. Попробуйте ещё раз.',
    errorTitle: 'Ошибка',
    errorGenericMessage: 'Не удалось открыть управление подпиской. Проверьте настройки устройства.',
    loadFailedTitle: 'Не удалось загрузить планы',
    loadFailedMessage: 'Мы не смогли загрузить планы подписки. Проверьте подключение к интернету и попробуйте ещё раз.',
    plansComingSoonTitle: 'Планы скоро появятся',
    plansComingSoonMessage: 'Планы подписки настраиваются. Загляните позже.',
    noPlansTitle: 'Нет доступных планов',
    noPlansMessage: 'Планы подписки настраиваются. Попробуйте позже.',
    tryAgain: 'Попробовать снова',
    activeSubscription: 'Активная подписка',
    planLabel: 'План {tier}',
    renewsDate: 'Продление {date}',
    expiresDate: 'Истекает {date}',
    manageSubscription: 'Управление подпиской',
    perMonth: '/мес.',
    perYear: '/год',
    savingsPercent: 'Экономия {percent}%',
    mostPopular: 'САМЫЙ ПОПУЛЯРНЫЙ',
    currentPlan: 'ТЕКУЩИЙ ПЛАН',
    selected: 'Выбрано',
    introTrialLabel: 'Пробный период: {price} за {period}',
    autoRenewalTerms: 'Подписки продлеваются автоматически, если не отменены за 24 часа до окончания текущего периода. Средства списываются в течение 24 часов до окончания текущего периода. Управлять подпиской или отменить ее можно в настройках учетной записи App Store.',
    selectedPlanRenewalDisclosure: 'Выбранный план: {title} за {price}{period}. Автоматически продлевается до отмены в настройках учетной записи App Store.',
    termsLink: 'Условия использования (EULA)',
    privacyLink: 'Политика конфиденциальности',
    ok: 'OK',
  },
  tl: {
    planTitleMonthly: 'Premium Buwanan',
    planTitleAnnual: 'Premium Taunan',
    planDescMonthly: 'I-unlock ang mga Premium na feature ng Bible quiz.',
    planDescAnnual: 'Taunang access sa Premium na Bible quiz.',
    premiumPlansTitle: 'Mga Premium na Plano',
    subscribeNow: 'Mag-subscribe Ngayon',
    restorePurchases: 'I-restore ang Mga Binili',
    restoring: 'Nire-restore...',
    refresh: 'I-refresh',
    loadingPlans: 'Nilo-load ang mga plano ng subscription...',
    purchaseSuccessTitle: 'Tagumpay!',
    purchaseSuccessMessage: 'Aktibo na ang iyong subscription. Mag-enjoy sa premium features!',
    purchaseFailedTitle: 'Hindi Nagtagumpay ang Pagbili',
    purchaseFailedMessage: 'Hindi makumpleto ang pagbili. Pakisubukan muli.',
    purchaseErrorTitle: 'Error sa Pagbili',
    purchaseErrorMessage: 'May hindi inaasahang error. Pakisubukan muli.',
    restoreSuccessTitle: 'Na-restore na ang Mga Binili!',
    restoreSuccessMessage: 'Matagumpay na na-restore ang iyong subscription.',
    noRestoredTitle: 'Walang Nahanap na Binili',
    noRestoredMessage: 'Walang aktibong subscription na mare-restore.',
    restoreFailedTitle: 'Hindi Nagtagumpay ang Pag-restore',
    restoreFailedMessage: 'Hindi mai-restore ang mga binili. Pakisubukan muli.',
    restoreErrorTitle: 'Error sa Pag-restore',
    restoreErrorMessage: 'May hindi inaasahang error. Pakisubukan muli.',
    errorTitle: 'Error',
    errorGenericMessage: 'Hindi mabuksan ang pamamahala ng subscription. Suriin ang mga setting ng device.',
    loadFailedTitle: 'Hindi Ma-load ang Mga Plano',
    loadFailedMessage: 'Hindi namin ma-load ang mga plano ng subscription. Suriin ang internet connection at subukan muli.',
    plansComingSoonTitle: 'Mga Plano ay Paparating Na',
    plansComingSoonMessage: 'Isineset up ang mga plano ng subscription. Bumalik mamaya.',
    noPlansTitle: 'Walang Available na Plano',
    noPlansMessage: 'Isineset up ang mga plano ng subscription. Subukan muli mamaya.',
    tryAgain: 'Subukan Muli',
    activeSubscription: 'Aktibong Subscription',
    planLabel: '{tier} na Plano',
    renewsDate: 'Magre-renew sa {date}',
    expiresDate: 'Mag-e-expire sa {date}',
    manageSubscription: 'Pamahalaan ang Subscription',
    perMonth: '/buwan',
    perYear: '/taon',
    savingsPercent: 'Makatipid ng {percent}%',
    mostPopular: 'PINAKAPOPULAR',
    currentPlan: 'KASALUKUYANG PLANO',
    selected: 'Napili',
    introTrialLabel: 'Pagsubok: {price} sa loob ng {period}',
    autoRenewalTerms: 'Awtomatikong magre-renew ang mga subscription maliban kung kanselahin 24 oras bago matapos ang kasalukuyang panahon. Sisingilin ang iyong account sa loob ng 24 oras bago matapos ang kasalukuyang panahon. Maaari mong i-manage o kanselahin sa App Store account settings.',
    selectedPlanRenewalDisclosure: 'Napiling plan: {title} sa {price}{period}. Awtomatikong magre-renew hanggang kanselahin sa App Store account settings.',
    termsLink: 'Mga Tuntunin ng Paggamit (EULA)',
    privacyLink: 'Patakaran sa Privacy',
    ok: 'OK',
  },
  it: {
    planTitleMonthly: 'Premium Mensile',
    planTitleAnnual: 'Premium Annuale',
    planDescMonthly: 'Sblocca le funzioni Premium del quiz.',
    planDescAnnual: 'Accesso annuale al quiz biblico Premium.',
    premiumPlansTitle: 'Piani Premium',
    subscribeNow: 'Abbonati ora',
    restorePurchases: 'Ripristina acquisti',
    restoring: 'Ripristino...',
    refresh: 'Aggiorna',
    loadingPlans: 'Caricamento piani di abbonamento...',
    purchaseSuccessTitle: 'Fatto!',
    purchaseSuccessMessage: 'Il tuo abbonamento è attivo. Goditi le funzioni premium!',
    purchaseFailedTitle: 'Acquisto fallito',
    purchaseFailedMessage: 'Impossibile completare l\'acquisto. Riprova.',
    purchaseErrorTitle: 'Errore di acquisto',
    purchaseErrorMessage: 'Si è verificato un errore imprevisto. Riprova.',
    restoreSuccessTitle: 'Acquisti ripristinati!',
    restoreSuccessMessage: 'Il tuo abbonamento è stato ripristinato con successo.',
    noRestoredTitle: 'Nessun acquisto trovato',
    noRestoredMessage: 'Nessun abbonamento attivo da ripristinare.',
    restoreFailedTitle: 'Ripristino fallito',
    restoreFailedMessage: 'Impossibile ripristinare gli acquisti. Riprova.',
    restoreErrorTitle: 'Errore di ripristino',
    restoreErrorMessage: 'Si è verificato un errore imprevisto. Riprova.',
    errorTitle: 'Errore',
    errorGenericMessage: 'Impossibile aprire la gestione abbonamenti. Controlla le impostazioni del dispositivo.',
    loadFailedTitle: 'Impossibile caricare i piani',
    loadFailedMessage: 'Non siamo riusciti a caricare i piani di abbonamento. Verifica la connessione internet e riprova.',
    plansComingSoonTitle: 'Piani in arrivo',
    plansComingSoonMessage: 'I piani di abbonamento sono in fase di configurazione. Torna presto.',
    noPlansTitle: 'Nessun piano disponibile',
    noPlansMessage: 'I piani di abbonamento sono in fase di configurazione. Riprova a breve.',
    tryAgain: 'Riprova',
    activeSubscription: 'Abbonamento attivo',
    planLabel: 'Piano {tier}',
    renewsDate: 'Rinnovo il {date}',
    expiresDate: 'Scade il {date}',
    manageSubscription: 'Gestisci abbonamento',
    perMonth: '/mese',
    perYear: '/anno',
    savingsPercent: 'Risparmia {percent}%',
    mostPopular: 'PIÙ POPOLARE',
    currentPlan: 'PIANO ATTUALE',
    selected: 'Selezionato',
    introTrialLabel: 'Prova: {price} per {period}',
    autoRenewalTerms: 'Gli abbonamenti si rinnovano automaticamente a meno che non vengano annullati 24 ore prima della fine del periodo corrente. L\'addebito avviene entro 24 ore prima della fine del periodo corrente. Puoi gestire o annullare nelle impostazioni del tuo account App Store.',
    selectedPlanRenewalDisclosure: 'Piano selezionato: {title} per {price}{period}. Si rinnova automaticamente finché non viene annullato nelle impostazioni del tuo account App Store.',
    termsLink: 'Condizioni d\'uso (EULA)',
    privacyLink: 'Informativa sulla privacy',
    ok: 'OK',
  },
  am: {
    planTitleMonthly: 'ፕሪሚየም ወርሃዊ',
    planTitleAnnual: 'ፕሪሚየም ዓመታዊ',
    planDescMonthly: 'የፕሪሚየም የመጽሐፍ ቅዱስ ጥያቄ ባህሪያትን ይክፈቱ።',
    planDescAnnual: 'የዓመት የፕሪሚየም የመጽሐፍ ቅዱስ ጥያቄ መዳረሻ።',
    premiumPlansTitle: 'ፕሪሚየም ዕቅዶች',
    subscribeNow: 'አሁን ይመዝገቡ',
    restorePurchases: 'ግዢዎችን ይመልሱ',
    restoring: 'በመመለስ ላይ...',
    refresh: 'አድስ',
    loadingPlans: 'የደንበኝነት ምዝገባ ዕቅዶች በመጫን ላይ...',
    purchaseSuccessTitle: 'ተሳክቷል!',
    purchaseSuccessMessage: 'የደንበኝነት ምዝገባዎ ንቁ ነው። የፕሪሚየም ባህሪያትን ይደሰቱ!',
    purchaseFailedTitle: 'ግዢ አልተሳካም',
    purchaseFailedMessage: 'ግዢውን ማጠናቀቅ አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    purchaseErrorTitle: 'የግዢ ስህተት',
    purchaseErrorMessage: 'ያልተጠበቀ ስህተት ተፈጥሯል። እባክዎ እንደገና ይሞክሩ።',
    restoreSuccessTitle: 'ግዢዎች ተመልሰዋል!',
    restoreSuccessMessage: 'የደንበኝነት ምዝገባዎ በተሳካ ሁኔታ ተመልሷል።',
    noRestoredTitle: 'ግዢዎች አልተገኙም',
    noRestoredMessage: 'ንቁ የደንበኝነት ምዝገባ ለመመለስ አልተገኘም።',
    restoreFailedTitle: 'መመለስ አልተሳካም',
    restoreFailedMessage: 'ግዢዎችን መመለስ አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    restoreErrorTitle: 'የመመለስ ስህተት',
    restoreErrorMessage: 'ያልተጠበቀ ስህተት ተፈጥሯል። እባክዎ እንደገና ይሞክሩ።',
    errorTitle: 'ስህተት',
    errorGenericMessage: 'የደንበኝነት ምዝገባ አስተዳደርን መክፈት አልተቻለም። የመሣሪያ ቅንብሮችን ያረጋግጡ።',
    loadFailedTitle: 'ዕቅዶችን መጫን አልተቻለም',
    loadFailedMessage: 'የደንበኝነት ምዝገባ ዕቅዶችን መጫን አልቻልንም። የበይነመረብ ግንኙነትዎን ያረጋግጡ እና እንደገና ይሞክሩ።',
    plansComingSoonTitle: 'ዕቅዶች በቅርቡ',
    plansComingSoonMessage: 'የደንበኝነት ምዝገባ ዕቅዶች በመዘጋጀት ላይ ናቸው። በቅርቡ ተመልሰው ይመልከቱ።',
    noPlansTitle: 'ዕቅዶች የሉም',
    noPlansMessage: 'የደንበኝነት ምዝገባ ዕቅዶች በመዘጋጀት ላይ ናቸው። በቅርቡ እንደገና ይሞክሩ።',
    tryAgain: 'እንደገና ይሞክሩ',
    activeSubscription: 'ንቁ ምዝገባ',
    planLabel: '{tier} ዕቅድ',
    renewsDate: '{date} ይታደሳል',
    expiresDate: '{date} ያበቃል',
    manageSubscription: 'ምዝገባን ያስተዳድሩ',
    perMonth: '/ወር',
    perYear: '/ዓመት',
    savingsPercent: '{percent}% ይቆጥቡ',
    mostPopular: 'በጣም ተወዳጅ',
    currentPlan: 'አሁን ያለው ዕቅድ',
    selected: 'ተመርጧል',
    introTrialLabel: 'ሙከራ: {price} ለ{period}',
    autoRenewalTerms: 'ከአሁኑ ጊዜ ማብቂያ 24 ሰዓት በፊት ካልተሰረዙ ምዝገባዎች በራስ-ሰር ይታደሳሉ። ከአሁኑ ጊዜ ማብቂያ 24 ሰዓት ውስጥ ሂሳብዎ ይከፈላል። በApp Store መለያ ቅንብሮች ውስጥ ማስተዳደር ወይም መሰረዝ ይችላሉ።',
    selectedPlanRenewalDisclosure: 'የተመረጠ ዕቅድ: {title} በ{price}{period}። በApp Store መለያ ቅንብሮች ውስጥ እስኪሰረዝ ድረስ በራስ-ሰር ይታደሳል።',
    termsLink: 'የአጠቃቀም ውሎች (EULA)',
    privacyLink: 'የግላዊነት ፖሊሲ',
    ok: 'OK',
  },
  ko: {
    planTitleMonthly: '프리미엄 월간',
    planTitleAnnual: '프리미엄 연간',
    planDescMonthly: '성경 퀴즈 프리미엄 기능을 잠금 해제합니다.',
    planDescAnnual: '성경 퀴즈 프리미엄 1년 이용권.',
    premiumPlansTitle: '프리미엄 플랜',
    subscribeNow: '지금 구독하기',
    restorePurchases: '구매 복원',
    restoring: '복원 중...',
    refresh: '새로고침',
    loadingPlans: '구독 플랜 로딩 중...',
    purchaseSuccessTitle: '완료!',
    purchaseSuccessMessage: '구독이 활성화되었습니다. 프리미엄 기능을 즐기세요!',
    purchaseFailedTitle: '구매 실패',
    purchaseFailedMessage: '구매를 완료할 수 없습니다. 다시 시도해 주세요.',
    purchaseErrorTitle: '구매 오류',
    purchaseErrorMessage: '예상치 못한 오류가 발생했습니다. 다시 시도해 주세요.',
    restoreSuccessTitle: '구매가 복원되었습니다!',
    restoreSuccessMessage: '구독이 성공적으로 복원되었습니다.',
    noRestoredTitle: '구매를 찾을 수 없음',
    noRestoredMessage: '복원할 활성 구독을 찾을 수 없습니다.',
    restoreFailedTitle: '복원 실패',
    restoreFailedMessage: '구매를 복원할 수 없습니다. 다시 시도해 주세요.',
    restoreErrorTitle: '복원 오류',
    restoreErrorMessage: '예상치 못한 오류가 발생했습니다. 다시 시도해 주세요.',
    errorTitle: '오류',
    errorGenericMessage: '구독 관리를 열 수 없습니다. 기기 설정을 확인해 주세요.',
    loadFailedTitle: '플랜을 불러올 수 없음',
    loadFailedMessage: '구독 플랜을 불러올 수 없습니다. 인터넷 연결을 확인하고 다시 시도해 주세요.',
    plansComingSoonTitle: '플랜 곧 출시',
    plansComingSoonMessage: '구독 플랜이 설정 중입니다. 곧 다시 확인해 주세요.',
    noPlansTitle: '이용 가능한 플랜 없음',
    noPlansMessage: '구독 플랜이 설정 중입니다. 잠시 후 다시 시도해 주세요.',
    tryAgain: '다시 시도',
    activeSubscription: '활성 구독',
    planLabel: '{tier} 플랜',
    renewsDate: '{date}에 갱신',
    expiresDate: '{date}에 만료',
    manageSubscription: '구독 관리',
    perMonth: '/월',
    perYear: '/년',
    savingsPercent: '{percent}% 절약',
    mostPopular: '가장 인기',
    currentPlan: '현재 플랜',
    selected: '선택됨',
    introTrialLabel: '체험: {period} 동안 {price}',
    autoRenewalTerms: '구독은 현재 기간 종료 24시간 전까지 취소하지 않으면 자동으로 갱신됩니다. 현재 기간 종료 24시간 이내에 계정에 요금이 청구됩니다. App Store 계정 설정에서 관리하거나 취소할 수 있습니다.',
    selectedPlanRenewalDisclosure: '선택한 플랜: {title}, {price}{period}. App Store 계정 설정에서 취소할 때까지 자동 갱신됩니다.',
    termsLink: '이용약관 (EULA)',
    privacyLink: '개인정보 처리방침',
    ok: '확인',
  },
};
